var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Box3, BufferGeometry, TextureLoader, Vector3 } from 'three';
export class ThreeUtils {
    getNodeBoundingBox(node) {
        const bbox = new Box3();
        bbox.setFromObject(node);
        return bbox;
    }
    get2DPosition(vector, camera, screenWidth, screenHeight) {
        const v = vector.project(camera);
        return {
            x: ((v.x + 1) * screenWidth) / 2,
            y: ((1 - v.y) * screenHeight) / 2,
        };
    }
    getMorphedBoundingBox(mesh) {
        if (!((mesh === null || mesh === void 0 ? void 0 : mesh.geometry) instanceof BufferGeometry)) {
            throw new Error('BufferGeometry expected');
        }
        const morphCount = mesh.morphTargetInfluences ? mesh.morphTargetInfluences.length : 0;
        const positions = mesh.geometry.getAttribute('position');
        const min = new Vector3(Infinity, Infinity, Infinity), max = new Vector3(-Infinity, -Infinity, -Infinity);
        for (let i = 0; i < positions.count; i++) {
            let x = positions.getX(i);
            for (let j = 0; j < morphCount; j++) {
                x += mesh.morphTargetInfluences[j] * mesh.geometry.morphAttributes.position[j].getX(i);
            }
            if (x < min.x) {
                min.x = x;
            }
            if (x > max.x) {
                max.x = x;
            }
            let y = positions.getY(i);
            for (let j = 0; j < morphCount; j++) {
                y += mesh.morphTargetInfluences[j] * mesh.geometry.morphAttributes.position[j].getY(i);
            }
            if (y < min.y) {
                min.y = y;
            }
            if (y > max.y) {
                max.y = y;
            }
            let z = positions.getZ(i);
            for (let j = 0; j < morphCount; j++) {
                z += mesh.morphTargetInfluences[j] * mesh.geometry.morphAttributes.position[j].getZ(i);
            }
            if (z < min.z) {
                min.z = z;
            }
            if (z > max.z) {
                max.z = z;
            }
        }
        return new Box3(min, max);
    }
    loadTexture(name) {
        return __awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve, reject) => {
                new TextureLoader().load(name, (texture) => {
                    resolve(texture);
                }, () => { }, () => {
                    reject(new Error(`Cannot load texture ${name}`));
                });
            });
        });
    }
    vectorToArray(vector) {
        return [vector.x, vector.y, vector.z];
    }
    arrayToVector(xs) {
        return new Vector3(xs[0], xs[1], xs[2]);
    }
}
export const threeUtils = new ThreeUtils();
//# sourceMappingURL=ThreeUtils.js.map